import React from 'react';
import PropTypes from 'prop-types';
import PreferencesSection from '../PreferencesSection';
import css from './TrackingNotifications.scss';
import { getWord } from 'utils/tenant';
import { SFEntityID, StaffNotificationPreferences } from 'utils/types';
import Checkbox from 'SF/Checkbox';
import TrackingRules from './TrackingRules';

const TrackingNotifications = ({ canAssignTrackingItems, hasEarlyAlert, notificationPreferences, setValue, userId }) => {
    
    return (
        <PreferencesSection isStaff
                            className={css['tracking-preferences']}
                            headerText={getWord('tracker') + ' Items'}
                            descriptionText={'Customize ' + getWord('tracker', true) + ' item notification preferences.'}>
            <h4>{getWord('tracker')} Item Updates</h4>
            <p>These may be emails and/or texts based on your institution’s settings and permissions to the items displayed below.</p>
            <label id="trackingUpdates">Send me an immediate notification for every:</label>
            <div className={css['tracking-updates']} aria-labelledby="trackingUpdates">
                <div>
                    <Checkbox ariaLabel="New item raised"
                              checked={notificationPreferences.flagRaised}
                              onChange={(checked) => setValue({ flagRaised: checked })} />
                    New item raised
                </div>
                <div>
                    <Checkbox ariaLabel="Item cleared"
                              checked={notificationPreferences.flagCleared}
                              onChange={(checked) => setValue({ flagCleared: checked })} />
                    Item cleared
                </div>
                { canAssignTrackingItems &&
                    <div>
                        <Checkbox ariaLabel="Item assigned to me"
                                  checked={notificationPreferences.flagAssigned}
                                  onChange={(checked) => setValue({ flagAssigned: checked })}/>
                        Item assigned to me
                    </div>
                }
            </div>
            { hasEarlyAlert && <TrackingRules userId={userId} /> }
        </PreferencesSection>
    );
};

TrackingNotifications.propTypes = {
    canAssignTrackingItems: PropTypes.bool,
    hasEarlyAlert: PropTypes.bool,
    notificationPreferences: StaffNotificationPreferences,
    setValue: PropTypes.func,
    userId: SFEntityID.isRequired
};

export default TrackingNotifications;
